import { useDateTime } from "../../shared";
import { DateTimeProps } from "./types";

const DateTime = ({ date, format, locale }: DateTimeProps) => {
    const { formattedDate } = useDateTime();

    return <>{formattedDate(date, format, locale)}</>;
};

export default DateTime;
